export class StringHelpers {
    static indexOfSubstring(text: string, searchText: string): number {
        return text.toLowerCase().indexOf(searchText.toLowerCase());
    }
}
